// UI-CRITICAL: Do not modify text structure without checking SEO impact.
import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
import { email } from '@config';
import { hero as heroContent } from '@config/content';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 1024px) and (min-width: 769px) {
    padding-top: var(--nav-height);
  }

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  .intro {
    display: block;
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;
    line-height: 1.1;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h1 {
    margin: 0;
  }

  h2 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 1.1;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) return;

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, [prefersReducedMotion]);

  const one = <div className="intro">{heroContent.greeting}</div>;
  const two = <h1 className="big-heading">{heroContent.name}</h1>;
  const three = <h2 className="big-heading">{heroContent.subtitle}</h2>;
  const four = <p>{heroContent.description}</p>;

  const five = (
    <a
      className="email-link"
      href={`mailto:${email}`}
    >
      {heroContent.cta}
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        items.map((item, i) => <div key={i}>{item}</div>)
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${(i + 1) * 100}ms` }}>
                  {item}
                </div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;